export const SkillsDefaults = {
	MaxSkillLevel: 100,
};
